import React from "react";

import { Modal } from "@material-ui/core";

import { Course, UserAllowedCourse, UserSubscription } from "@remar/shared/dist/models";

import { useStyles } from "@remar/shared/dist/styles";

import ManageSubscription from "../../App/View/Container/ManageStudents/components/ManageSubscription";

export interface IChangeSubscription {
	fullName: string;
	userId: number;
	subscriptionId: number;
	hasExpired: boolean;
	isCancelled: boolean;
	isTrial: boolean | undefined;
	allowedCourses: UserAllowedCourse[] | undefined;
	notAllowedCourses: Course[] | null;
	subscription: UserSubscription;
	isRecurring?: boolean;
}

const ChangeSubscriptionModal = ({
	setShowChangeSubscriptionModal,
	showChangeSubscriptionModal: {
		allowedCourses,
		notAllowedCourses,
		userId,
		fullName,
		subscriptionId,
		hasExpired,
		isCancelled,
		isTrial,
		isRecurring = false
	},
	fetchAccount = false
}: {
	setShowChangeSubscriptionModal: React.Dispatch<React.SetStateAction<IChangeSubscription | null>>;
	showChangeSubscriptionModal: IChangeSubscription;
	fetchAccount?: boolean;
}) => {
	const classes = useStyles();
	return (
		<Modal
			className={classes.modal}
			disableEnforceFocus
			disableAutoFocus
			open={true}
			onClose={() => setShowChangeSubscriptionModal(null)}
		>
			<ManageSubscription
				onClose={() => setShowChangeSubscriptionModal(null)}
				allowedCourses={allowedCourses}
				notAllowedCourses={notAllowedCourses}
				fullName={fullName}
				subscriptionId={subscriptionId}
				disabled={hasExpired || isCancelled || isTrial || isTrial === undefined}
				userId={userId}
				fetchAccount={fetchAccount}
				isRecurring={isRecurring}
			/>
		</Modal>
	);
};

export default ChangeSubscriptionModal;
